import Head from 'next/head'
import { useRouter } from 'next/router'
import { useCity } from '@/contexts/CityContext'

export default function CustomHead({ meta }) {
    const router = useRouter()
    const { city, cities } = useCity() // <-- вот так получаем города из контекста

    const firstSegment = router.asPath.split('/').filter(Boolean)[0] || ''
    const isCityPage = cities?.some(c => c.slug === firstSegment) && router.asPath === `/${firstSegment}`

    return (
        <Head>
            <title key="page">
                {meta?.title ?? 'Центр финансовых консультаций: помощь в подборе кредита и лизинга'}
            </title>

            <meta
                property="og:title"
                content={meta?.title ?? 'Центр финансовых консультаций: помощь в подборе кредита и лизинга'}
                key="title"
            />
            <meta
                property="og:description"
                content={meta?.description ?? 'Центр финансовых консультаций: поможем подобрать выгодный кредит в Беларуси. Товары в лизинг. Даже с плохой кредитной историей. Звоните: +375(29)888-3-22'}
                key="ogDescription"
            />
            <meta
                name="description"
                content={meta?.description ?? 'Центр финансовых консультаций: поможем подобрать выгодный кредит в Беларуси. Товары в лизинг. Даже с плохой кредитной историей. Звоните: +375(29)888-3-22'}
                key="description"
            />

            {(meta?.is_robots_disallows || isCityPage) && (
                <meta name="robots" content="noindex, nofollow" />
            )}
        </Head>
    )
}
